<template>
  <div class="procurementBidding wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-tree-table">
      <sliderTree
        ref="sliderTree"
        :data="data"
        @handleNodeClick="handleNodeClick"
      ></sliderTree>
      <div class="ccui-app-container">
        <div
          class="ccui-advanced-search-wrapper ccui-clearfix"
          v-if="!isShowDetail"
        >
          <div class="content-text">
            <!--<img
              src="../../../assets/images/content_null.png"
              class="content-null-image"
              alt
            />-->
            <p class="content-null-text">
              {{ $t("page.content.noRelatedData") }}
            </p>
          </div>
        </div>
        <div class="ccui-advanced-search-wrapper ccui-clearfix" v-else>
          <div class="dic-view">
            <div class="title-box ccui-clearfix">
              <span class="content-title fl" :title="faqProblemBO.faqName">
                {{ faqProblemBO.faqName }}
              </span>
            </div>
            <!--<div class="little-title">
              <span>来源： {{ faqProblemBO.publishTime }}</span>
              <span>作责 {{ faqProblemBO.readingCnt }}</span>
              <span>发布时间 {{ faqProblemBO.publishUser }}</span>
            </div>-->
            <el-divider></el-divider>
            <div class="content-detail" v-html="faqProblemBO.textContent"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import sliderTree from "@/app/shop/components/slideTree.vue";
import { listFaqProblem, getFaqProblemById } from "@/app/shop/api/shopping";
export default {
  name: "operationHandbook",
  components: {
    baseBreadCrumb,
    sliderTree
  },
  data() {
    return {
      currBreadCrumb: [
        { title: this.$t("page.content.supplierOperationManual") }
      ],
      data: [
        {
          label: this.$t("page.content.operationManual"),
          isParent: true,
          faqId: 1,
          children: []
        }
      ],
      dicArr: [],
      isShowDetail: false,
      pageSizeCode: 20,
      pageNoCode: 1,
      total: 1000,
      pagesize: [10, 20, 50, 100, 200, 500],
      expendedIdArr: [69],
      faqProblemBO: {},
      defaultCheckedKeys: this.$route.query.faqId
        ? [this.$route.query.faqId]
        : []
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      listFaqProblem({
        pageNo: 1,
        pageSize: 10,
        faqClassifyId: this.$route.query.id
        // faqClassifyCode: "SCP_PRO"
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.faqProblemBOs.map(item => {
            item.label = item.faqName;
            return item;
          });
          this.$set(this.data[0], "children", res.data.data.faqProblemBOs);
          if (this.$route.query.faqId) {
            this.getDetail({ faqId: this.$route.query.faqId });
            this.$nextTick(() => {
              this.$refs.sliderTree.$refs.tree.setCurrentKey(
                this.$route.query.faqId
              );
            });
          }
        }
      });
    },

    getDetail(obj) {
      this.isShowDetail = true;
      this.$route.query.faqId = obj.faqId;
      getFaqProblemById({
        faqId: obj.faqId
      }).then(res => {
        if (res.data.code === "0") {
          this.faqProblemBO = res.data.data.faqProblemBO;
        }
      });
    },
    handleNodeClick(obj) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query.faqId = obj.faqId; //state 修改的参数
      this.$router.push({ query });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/config/styles/question-edit.scss";
/deep/ .el-tree-node__content {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

/* 改变被点击节点背景颜色，字体颜色 */
/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: #f8f8f8 !important;
  color: #4a9de7 !important;
}
/*节点失焦时的背景颜色*/
/deep/
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #f8f8f8 !important;
  color: #4a9de7 !important;
}
// .ccui-tree-table .ccui-tree-wrapper /deep/ .el-tree-node__content span {
//   font-size: 14px;
//   font-weight: 600;
//   line-height: 20px;
//   height: 20px;
// }
/deep/ .el-tree-node > .el-tree-node__content {
  margin-bottom: 20px;
}
/deep/ .el-tree-node__children > .el-tree-node .el-tree-node__content {
  margin-bottom: 10px;
}
/deep/ .el-tree-node__children {
  transition: all 0.1s ease 0s;
}
/deep/ #ccui-paging .ccui-pagination-btn {
  display: block !important;
  margin-left: 5px;
  border-radius: 0;
}
/deep/ .detail-title {
  display: flex;
  justify-content: space-between;
  span:last-child {
    width: 82px;
    height: 20px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999990;
    letter-spacing: 0;
    font-weight: 400;
  }
}
.ccui-tree-table .ccui-app-container {
  overflow: hidden;
}
</style>
